/* ===== v128 loading screen font gate minimum duration ===== */
(function () {
  var root = document.documentElement;
  var done = false;
  var timeoutId;
  var loaderStartedAt = Date.now();
  var MIN_LOADER_MS = 5000;

  root.classList.add('noahq-home-fonts-loading', 'noahq-loading');

  function finishReveal(timeout) {
    if (done) return;
    done = true;

    if (timeoutId) window.clearTimeout(timeoutId);

    root.classList.remove('noahq-loading');
    root.classList.remove('noahq-home-fonts-loading');
    root.classList.add(timeout ? 'noahq-home-fonts-timeout' : 'noahq-home-fonts-ready');

    window.setTimeout(function () {
      var loader = document.querySelector('[data-noahq-font-loader]');
      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }
    }, 520);
  }

  function reveal(timeout) {
    var elapsed = Date.now() - loaderStartedAt;
    var wait = Math.max(0, MIN_LOADER_MS - elapsed);

    window.setTimeout(function () {
      finishReveal(timeout);
    }, wait);
  }

  function hasNoahqHome() {
    return !!document.querySelector('.noahq-home');
  }

  function start() {
    if (!hasNoahqHome()) {
      reveal(false);
      return;
    }

    timeoutId = window.setTimeout(function () {
      reveal(true);
    }, 2600);

    if (!document.fonts || typeof document.fonts.load !== 'function') {
      reveal(true);
      return;
    }

    var fontLoads = [
      document.fonts.load('1em "prohibition"'),
      document.fonts.load('1em "kaisotai"'),
      document.fonts.load('1em "ab-kokoro-no3"')
    ];

    Promise.allSettled(fontLoads)
      .then(function () {
        return document.fonts.ready;
      })
      .then(function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            reveal(false);
          });
        });
      })
      .catch(function () {
        reveal(true);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();




(() => {
  const injectHeroRotatorStyles = () => {
    if (document.getElementById('noahq-hero-rotator-style')) return;

    const style = document.createElement('style');
    style.id = 'noahq-hero-rotator-style';
    style.textContent = `
      .noahq-hero h1.noahq-hero-copy {
        position: relative;
        display: grid;
        gap: clamp(.06em, .75vmin, .14em);
        width: fit-content;
        max-width: min(100%, 74rem);
        margin: 0 auto;
        isolation: isolate;
        text-transform: uppercase;
        font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', 'Anton', sans-serif;
        font-weight: 1000;
        letter-spacing: -.035em;
        line-height: .9;
        text-align: center;
      }
      .noahq-hero h1.noahq-hero-copy span,
      .noahq-hero-copy__line,
      .noahq-hero-copy__brand {
        position: relative;
        display: block;
        background: none;
        -webkit-background-clip: initial;
        background-clip: initial;
        color: var(--nq-ink, #101014);
      }
      .noahq-hero-copy__line {
        min-height: .88em;
        will-change: transform, filter, opacity;
        transition: opacity .18s ease, transform .18s ease, filter .18s ease;
      }
      .noahq-hero-copy__line--one { font-size: clamp(6.2rem, 10.2vmin, 12.6rem); }
      .noahq-hero-copy__line--two {
        min-height: .88em;
        font-size: clamp(8rem, 13.4vmin, 16rem);
        color: transparent !important;
        background: linear-gradient(90deg, var(--nq-pink, #ff75cf), var(--nq-violet, #9877ff), var(--nq-cyan, #64efff)) !important;
        -webkit-background-clip: text !important;
        background-clip: text !important;
      }
      .noahq-hero-copy__brand {
        font-size: clamp(8.1rem, 13.8vmin, 16.4rem);
        color: var(--nq-ink, #101014) !important;
        text-shadow: -.018em 0 var(--nq-pink, #ff75cf), .018em 0 var(--nq-cyan, #64efff);
      }
      .noahq-hero-copy::after {
        content: "";
        position: absolute;
        inset: -.08em -.05em;
        z-index: 3;
        pointer-events: none;
        opacity: 0;
        mix-blend-mode: multiply;
        background:
          repeating-linear-gradient(0deg, rgba(16,16,20,.18) 0 1px, transparent 1px 5px),
          repeating-linear-gradient(90deg, rgba(255,117,207,.14) 0 2px, rgba(100,239,255,.12) 2px 4px, transparent 4px 9px);
      }
      .noahq-hero-copy__line::before,
      .noahq-hero-copy__line::after {
        content: attr(data-text);
        position: absolute;
        inset: 0;
        opacity: 0;
        pointer-events: none;
      }
      .noahq-hero-copy__line::before {
        color: var(--nq-pink, #ff75cf);
        transform: translateX(-.035em);
        clip-path: inset(0 0 48% 0);
      }
      .noahq-hero-copy__line::after {
        color: var(--nq-cyan, #64efff);
        transform: translateX(.035em);
        clip-path: inset(52% 0 0 0);
      }
      .noahq-hero-copy.is-glitching::after { animation: noahqHeroNoise .46s steps(2, end); }
      .noahq-hero-copy.is-glitching .noahq-hero-copy__line {
        animation: noahqHeroJolt .46s steps(2, end);
        filter: contrast(1.28) saturate(1.4);
      }
      .noahq-hero-copy.is-glitching .noahq-hero-copy__line::before,
      .noahq-hero-copy.is-glitching .noahq-hero-copy__line::after { animation: noahqHeroGhost .46s steps(2, end); }
      @keyframes noahqHeroNoise {
        0%, 100% { opacity: 0; transform: translate(0, 0); }
        15% { opacity: .55; transform: translate(.02em, -.015em); }
        33% { opacity: .18; transform: translate(-.03em, .018em); }
        54% { opacity: .45; transform: translate(.04em, .01em); }
        73% { opacity: .25; transform: translate(-.015em, -.02em); }
      }
      @keyframes noahqHeroJolt {
        0%, 100% { transform: translate(0, 0) skewX(0); opacity: 1; }
        18% { transform: translate(.035em, -.01em) skewX(-3deg); opacity: .92; }
        40% { transform: translate(-.04em, .015em) skewX(2deg); opacity: .98; }
        62% { transform: translate(.025em, .02em) skewX(-1deg); opacity: .88; }
      }
      @keyframes noahqHeroGhost {
        0%, 100% { opacity: 0; }
        16% { opacity: .9; }
        42% { opacity: .55; }
        64% { opacity: .75; }
      }
      @media screen and (max-width: 749px) {
        .noahq-hero h1.noahq-hero-copy { gap: .12em; }
        .noahq-hero-copy__line--one { font-size: clamp(4.8rem, 15vw, 7.6rem); }
        .noahq-hero-copy__line--two,
        .noahq-hero-copy__brand { font-size: clamp(5.9rem, 18.2vw, 9rem); }
      }
    `;
    document.head.appendChild(style);
  };

  const initHeroRotator = () => {
    const title = document.querySelector('.noahq-hero h1');
    if (!title || title.dataset.noahqRotatorReady === 'true') return;
    const phrases = [['BEST','CHOICE'], ['GET IT','FROM'], ['NEW','ARRIVAL']];
    injectHeroRotatorStyles();
    title.dataset.noahqRotatorReady = 'true';
    title.classList.add('noahq-hero-copy');
    title.setAttribute('aria-live', 'polite');
    title.innerHTML = `<span class="noahq-hero-copy__line noahq-hero-copy__line--one" data-noahq-line-one data-text="BEST">BEST</span><span class="noahq-hero-copy__line noahq-hero-copy__line--two" data-noahq-line-two data-text="CHOICE">CHOICE</span><span class="noahq-hero-copy__brand">NOAH.Q</span>`;
    const lineOne = title.querySelector('[data-noahq-line-one]');
    const lineTwo = title.querySelector('[data-noahq-line-two]');
    let currentIndex = 0;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const setPhrase = (index, animate = true) => {
      const phrase = phrases[index];
      if (!phrase) return;
      const applyText = () => {
        lineOne.textContent = phrase[0];
        lineTwo.textContent = phrase[1];
        lineOne.dataset.text = phrase[0];
        lineTwo.dataset.text = phrase[1];
        currentIndex = index;
      };
      if (!animate || reduceMotion) { applyText(); return; }
      title.classList.add('is-glitching');
      window.setTimeout(applyText, 170);
      window.setTimeout(() => title.classList.remove('is-glitching'), 520);
    };
    const pickNextIndex = () => {
      let nextIndex = currentIndex;
      while (nextIndex === currentIndex) nextIndex = Math.floor(Math.random() * phrases.length);
      return nextIndex;
    };
    setPhrase(0, false);
    window.setInterval(() => setPhrase(pickNextIndex(), true), reduceMotion ? 5200 : 3400);
  };


  const initMarquee = () => {
    const track = document.querySelector('[data-noahq-marquee]');
    if (!track || track.dataset.noahqMarqueeReady === 'true') return;

    const fromData = (track.dataset.keywords || '')
      .split('|')
      .map((item) => item.trim())
      .filter(Boolean);

    const fromDom = Array.from(track.querySelectorAll('span'))
      .map((span) => span.textContent.trim())
      .filter(Boolean);

    const baseKeywords = Array.from(new Set(fromData.length ? fromData : fromDom));
    if (!baseKeywords.length) return;

    const pickSequence = () => {
      const targetLength = Math.max(18, baseKeywords.length * 2);
      const sequence = [];
      let guard = 0;

      while (sequence.length < targetLength && guard < targetLength * 20) {
        guard += 1;
        const next = baseKeywords[Math.floor(Math.random() * baseKeywords.length)];
        if (sequence.length && sequence[sequence.length - 1] === next) continue;
        sequence.push(next);
      }

      return sequence.length ? sequence : baseKeywords;
    };

    const sequence = pickSequence();

    const buildGroup = (hidden = false) => {
      const group = document.createElement('div');
      group.className = 'noahq-marquee__group';
      if (hidden) group.setAttribute('aria-hidden', 'true');

      sequence.forEach((keyword) => {
        const span = document.createElement('span');
        span.textContent = keyword;
        group.appendChild(span);
      });

      return group;
    };

    track.replaceChildren(buildGroup(false), buildGroup(true));
    track.dataset.noahqMarqueeReady = 'true';
  };


  const initWatchlist = () => {
    const cards = Array.from(document.querySelectorAll('[data-noahq-watch-card]'));
    if (!cards.length) return;

    const storageKey = 'noahqWatchlist:v1';

    const canUseLocalStorage = () => {
      try {
        window.localStorage.setItem('__nq_watch_test__', '1');
        window.localStorage.removeItem('__nq_watch_test__');
        return true;
      } catch (_error) {
        return false;
      }
    };

    const storageAvailable = canUseLocalStorage();

    const readWatched = () => {
      if (!storageAvailable) return new Set();
      try {
        const parsed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
        return new Set(Array.isArray(parsed) ? parsed.map(String) : []);
      } catch (_error) {
        return new Set();
      }
    };

    const writeWatched = (watched) => {
      if (!storageAvailable) return;
      window.localStorage.setItem(storageKey, JSON.stringify(Array.from(watched)));
    };

    const formatCount = (value) => {
      const number = Number(value) || 0;
      return new Intl.NumberFormat('en-US').format(number);
    };

    const watched = readWatched();

    const syncProduct = (productId) => {
      const isWatched = watched.has(productId);

      cards
        .filter((card) => String(card.dataset.productId) === productId)
        .forEach((card) => {
          const baseLikes = Number(card.dataset.baseLikes || 0);
          const countNode = card.querySelector('[data-noahq-watch-count]');
          const button = card.querySelector('[data-noahq-watch-button]');
          const icon = card.querySelector('[data-noahq-watch-icon]');
          const label = card.querySelector('[data-noahq-watch-label]');
          const nextCount = baseLikes + (isWatched ? 1 : 0);

          card.classList.toggle('is-watched', isWatched);

          if (countNode) countNode.textContent = formatCount(nextCount);

          if (button) {
            button.classList.toggle('is-watched', isWatched);
            button.setAttribute('aria-pressed', isWatched ? 'true' : 'false');
            button.setAttribute('aria-label', isWatched ? 'ウォッチリストから削除' : 'ウォッチリストに追加');
          }

          if (icon) icon.textContent = isWatched ? '♥' : '♡';
          if (label) label.textContent = isWatched ? 'ウォッチリストから削除' : 'ウォッチリストに追加';
        });
    };

    cards.forEach((card) => {
      if (card.dataset.noahqWatchReady === 'true') {
        syncProduct(String(card.dataset.productId));
        return;
      }

      const productId = String(card.dataset.productId || '');
      const button = card.querySelector('[data-noahq-watch-button]');
      if (!productId || !button) return;

      card.dataset.noahqWatchReady = 'true';
      syncProduct(productId);

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (watched.has(productId)) watched.delete(productId);
        else watched.add(productId);

        writeWatched(watched);
        syncProduct(productId);

        button.classList.remove('is-popping');
        void button.offsetWidth;
        button.classList.add('is-popping');
      });
    });
  };


  const initHeaderPanelContrast = () => {
    const valuesPanel = document.querySelector('.noahq-scroll-showcase > .noahq-values');
    const headerWrapper = document.querySelector('sticky-header.header-wrapper, .header-wrapper');
    if (!valuesPanel || !headerWrapper || headerWrapper.dataset.noahqPanelContrastReady === 'true') return;

    headerWrapper.dataset.noahqPanelContrastReady = 'true';

    const textSelector = [
      '.noahq-art-header-nav a',
      '.header__heading-link .h2',
      '.header__heading-link span.h2',
      '.header__heading-link span:not(.svg-wrapper)'
    ].join(',');

    const iconSelector = '.header__icons .header__icon:not(.header__icon--cart)';

    const switchSelector = [
      '.header__heading-logo',
      '.header__heading-logo-wrapper img',
      '.noahq-header-brand-name'
    ].join(',');

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const getTextTargets = () => Array.from(document.querySelectorAll(textSelector))
      .filter((element) => element.textContent.trim().length);

    const getIconTargets = () => Array.from(document.querySelectorAll(iconSelector));

    const getSwitchTargets = () => Array.from(document.querySelectorAll(switchSelector));

    const syncTextLabels = () => {
      getTextTargets().forEach((element) => {
        const label = element.textContent.trim();
        if (!label) return;
        if (element.dataset.noahqHeaderText !== label) {
          element.dataset.noahqHeaderText = label;
        }
      });
    };

    const syncIconLayers = () => {
      getIconTargets().forEach((icon) => {
        if (icon.dataset.noahqHeaderIconContrastReady === 'true') return;

        const wrappers = Array.from(icon.querySelectorAll('.svg-wrapper'));
        if (!wrappers.length) return;

        const layer = document.createElement('span');
        layer.className = 'noahq-header-icon-light-layer';
        layer.setAttribute('aria-hidden', 'true');

        wrappers.forEach((wrapper) => {
          const clone = wrapper.cloneNode(true);
          clone.classList.add('noahq-header-icon-light-clone');
          layer.appendChild(clone);
        });

        icon.appendChild(layer);
        icon.classList.add('noahq-header-icon-contrast');
        icon.dataset.noahqHeaderIconContrastReady = 'true';
      });
    };

    let ticking = false;

    const update = () => {
      ticking = false;
      syncTextLabels();
      syncIconLayers();

      const panelTop = valuesPanel.getBoundingClientRect().top;

      getTextTargets().forEach((element) => {
        const rect = element.getBoundingClientRect();
        const height = Math.max(rect.height || 0, 1);
        const progress = clamp((rect.bottom - panelTop) / height, 0, 1);
        const clip = (1 - progress) * 100;

        element.style.setProperty('--nq-header-item-clip', `${clip.toFixed(2)}%`);
        element.classList.toggle('is-noahq-header-light-active', progress > 0.01);
        element.classList.toggle('is-noahq-header-light-full', progress > 0.99);
      });

      getIconTargets().forEach((icon) => {
        const rect = icon.getBoundingClientRect();
        const height = Math.max(rect.height || 0, 1);
        const progress = clamp((rect.bottom - panelTop) / height, 0, 1);
        const clip = (1 - progress) * 100;

        icon.style.setProperty('--nq-header-item-clip', `${clip.toFixed(2)}%`);
        icon.classList.toggle('is-noahq-header-light-active', progress > 0.01);
        icon.classList.toggle('is-noahq-header-light-full', progress > 0.99);
      });

      const nav = document.querySelector('.noahq-art-header-nav');
      if (nav) {
        const rect = nav.getBoundingClientRect();
        const progress = clamp((rect.bottom - panelTop) / Math.max(rect.height || 0, 1), 0, 1);
        nav.classList.toggle('is-noahq-header-line-light', progress > 0.5);
      }

      getSwitchTargets().forEach((element) => {
        const rect = element.getBoundingClientRect();
        const centerY = rect.top + (rect.height * 0.5);
        element.classList.toggle('is-noahq-header-light-full', panelTop <= centerY);
      });
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('orientationchange', requestUpdate);
  };


  const initValuesCardReveal = () => {
    const section = document.querySelector('.noahq-scroll-showcase > .noahq-values');
    if (!section) return;

    const sticky = section.querySelector('[data-noahq-values-sticky], .noahq-values__sticky');
    const cards = Array.from(section.querySelectorAll('.noahq-value-card'));
    if (!sticky || !cards.length) return;

    if (section.dataset.noahqValuesRevealReady === 'true') return;

    section.dataset.noahqValuesRevealReady = 'true';
    section.classList.add('is-values-reveal-ready');

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    /*
      v93 clean timeline.
      Sticky range is shorter and the last text reveal finishes close to release.
      One-way state is retained: reveals do not reverse.
    */
    const thresholds = [0.03, 0.28, 0.53, 0.78];
    const revealLength = 0.055;
    const textDelayAfterMotion = 0.008;
    const textRevealLength = 0.128;

    const cardState = cards.map(() => ({
      cardProgress: 0,
      textProgress: 0
    }));

    let highestProgress = 0;
    let hasPassedOnce = false;
    let returnSkipLocked = false;
    let lastScrollY = window.scrollY || window.pageYOffset || 0;
    let ticking = false;

    const update = () => {
      ticking = false;

      const currentScrollY = window.scrollY || window.pageYOffset || 0;
      const isScrollingUp = currentScrollY < lastScrollY;
      lastScrollY = currentScrollY;

      const rect = section.getBoundingClientRect();
      const viewportHeight = Math.max(window.innerHeight || document.documentElement.clientHeight || 1, 1);
      const scrollRange = Math.max(rect.height - viewportHeight, 1);
      const rawProgress = clamp((0 - rect.top) / scrollRange, 0, 1);

      /*
        After the user has fully passed this section once, the return trip should not
        force them through the sticky range again. We lock a skip state just before
        the section re-enters from below while scrolling upward.
      */
      if (hasPassedOnce && !returnSkipLocked && isScrollingUp && rect.bottom > -(viewportHeight * 0.35)) {
        const anchor = document.elementFromPoint(Math.max(1, window.innerWidth * 0.5), Math.max(1, viewportHeight * 0.5));
        const anchorTopBefore = anchor ? anchor.getBoundingClientRect().top : null;

        returnSkipLocked = true;
        section.classList.add('is-values-return-skip');
        highestProgress = 1;

        cardState.forEach((state) => {
          state.cardProgress = 1;
          state.textProgress = 1;
        });

        cards.forEach((card) => {
          card.style.setProperty('--nq-card-reveal', '1.0000');
          card.style.setProperty('--nq-card-text-reveal', '1.0000');
          card.classList.add('is-revealed', 'is-text-revealed', 'is-fully-revealed');
        });

        section.classList.add('is-values-complete');

        if (anchor && anchorTopBefore !== null) {
          window.requestAnimationFrame(() => {
            const anchorTopAfter = anchor.getBoundingClientRect().top;
            window.scrollBy(0, anchorTopAfter - anchorTopBefore);
          });
        }

        return;
      }

      highestProgress = Math.max(highestProgress, rawProgress);
      const progress = highestProgress;

      section.style.setProperty('--nq-values-progress', progress.toFixed(4));

      let allTextComplete = true;

      cards.forEach((card, index) => {
        const threshold = thresholds[index] ?? thresholds[thresholds.length - 1];
        const nextCardProgress = clamp((progress - threshold) / revealLength, 0, 1);
        const textStart = threshold + revealLength + textDelayAfterMotion;
        const nextTextProgress = clamp((progress - textStart) / textRevealLength, 0, 1);
        const state = cardState[index];

        state.cardProgress = Math.max(state.cardProgress, nextCardProgress);
        state.textProgress = Math.max(state.textProgress, nextTextProgress);

        if (state.textProgress < 0.99) allTextComplete = false;

        card.style.setProperty('--nq-card-reveal', state.cardProgress.toFixed(4));
        card.style.setProperty('--nq-card-text-reveal', state.textProgress.toFixed(4));
        card.classList.toggle('is-revealed', state.cardProgress > 0.01);
        card.classList.toggle('is-text-revealed', state.textProgress > 0.01);
        card.classList.toggle('is-fully-revealed', state.cardProgress > 0.99);
      });

      if (allTextComplete && rawProgress > 0.98) {
        hasPassedOnce = true;
      }

      section.classList.toggle('is-values-complete', allTextComplete);
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('orientationchange', requestUpdate);
  };

  const opening = document.querySelector('[data-noahq-opening]');
  const enterButton = document.querySelector('[data-noahq-enter]');
  const timeNode = document.querySelector('[data-noahq-time]');
  const storageKey = 'noahqOpeningSeen';
  const lockClass = 'noahq-opening-lock';
  const canUseStorage = () => {
    try { window.sessionStorage.setItem('__nq_test__', '1'); window.sessionStorage.removeItem('__nq_test__'); return true; }
    catch (_error) { return false; }
  };
  const storageAvailable = canUseStorage();
  const hasSeenOpening = storageAvailable && window.sessionStorage.getItem(storageKey) === 'true';
  if (opening && hasSeenOpening) opening.remove();
  else if (opening) { document.documentElement.classList.add(lockClass); document.body.classList.add(lockClass); }
  const updateTime = () => {
    if (!timeNode) return;
    const now = new Date();
    const formatted = new Intl.DateTimeFormat('ja-JP', {hour:'2-digit', minute:'2-digit', timeZone:'Asia/Tokyo'}).format(now);
    timeNode.textContent = `${formatted} JST`;
  };
  const closeOpening = () => {
    if (!opening) return;
    if (storageAvailable) window.sessionStorage.setItem(storageKey, 'true');
    document.documentElement.classList.remove(lockClass);
    document.body.classList.remove(lockClass);
    opening.classList.add('is-hidden');
    window.setTimeout(() => opening.remove(), 900);
  };
  initHeroRotator();
  initMarquee();
  initWatchlist();
  initHeaderPanelContrast();
  initValuesCardReveal();
  updateTime();
  window.setInterval(updateTime, 30000);
  enterButton?.addEventListener('click', closeOpening);
  if (opening && !hasSeenOpening && opening.dataset.autoClose === 'true') window.setTimeout(closeOpening, 1800);
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.documentElement.classList.remove(lockClass);
    document.body.classList.remove(lockClass);
    initHeroRotator();
    initMarquee();
    initWatchlist();
    initHeaderPanelContrast();
    initValuesCardReveal();
  });
})();
